import React, { useEffect, useState, useRef } from 'react';
import { FaQuoteLeft } from 'react-icons/fa';
import u1 from '../assets/u1.jpg';
import u2 from '../assets/u2.png';

const TestimonialsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setIsVisible(entry.isIntersecting);
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const getScrollAnimatedStyle = (delay) => ({
    transform: isVisible ? 'translateY(0)' : 'translateY(50px)',
    opacity: isVisible ? 1 : 0,
    transition: `transform 0.8s ease-out ${delay}s, opacity 0.8s ease-out ${delay}s`,
  });

  const testimonials = [
    {
      text: "Food's fire 🔥, view's a vibe, and the ambiance is totally Insta-worthy. Quick and kind service too!",
      name: 'Kunal',
      avatar: u1,
    },
    {
      text: 'Tasty food, beautiful setting, polite service, and a peaceful atmosphere. Worth the visit!',
      name: 'Simran',
      avatar: u2,
    },
  ];

  return (
    <section
      style={{
        backgroundColor: '#f9f6f1',
        padding: '60px 20px',
        textAlign: 'center',
        fontFamily: 'Arial, sans-serif',
        overflow: 'hidden',
      }}
      ref={sectionRef}
    >
      <div style={{ color: '#d4a017', fontSize: '18px', fontWeight: '500', ...getScrollAnimatedStyle(0.1) }}>
        OUR TESTIMONIALS
      </div>
      <div
        style={{
          fontSize: '33px',
          fontWeight: 'bold',
          marginBottom: '5px',
          color: '#111',
          fontFamily: "'Playfair Display', serif",
          ...getScrollAnimatedStyle(0.3),
        }}
      >
        Real Stories Of Memorable
      </div>
      <div
        style={{
          color: '#d4a017',
          fontSize: '33px',
          fontWeight: '500',
          marginBottom: '40px',
          fontFamily: "'Playfair Display', serif",
          ...getScrollAnimatedStyle(0.5),
        }}
      >
        Meals & Experience
      </div>

      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: '40px',
          marginTop: '40px',
        }}
      >
        {testimonials.map((testimonial, index) => (
          <div
            key={index}
            className="testimonial-group"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              maxWidth: '450px',
              width: '100%',
              padding: '0 15px',
              textAlign: 'left',
              ...getScrollAnimatedStyle(0.7 + index * 0.2),
            }}
          >
            <div className="testimonial-card">
              <div className="quote-icon">
                <FaQuoteLeft />
              </div>
              <p className="testimonial-text">{testimonial.text}</p>
            </div>
            <div className="triangle" />
            <div className="profile">
              <img src={testimonial.avatar} alt={testimonial.name} className="avatar" />
              <div className="name">{testimonial.name}</div>
            </div>
          </div>
        ))}
      </div>

      <style>{`
        .testimonial-card {
          background-color: #fff;
          border-radius: 6px;
          padding: 20px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
          transition: all 0.3s ease;
        }

        .quote-icon {
          font-size: 30px;
          color: #d4a017;
          margin-bottom: 10px;
          transition: color 0.3s ease;
        }

        .testimonial-text {
          font-size: 16px;
          color: #333;
          line-height: 1.6;
          transition: color 0.3s ease;
        }

        .triangle {
          width: 0;
          height: 0;
          border-left: 15px solid transparent;
          border-right: 15px solid transparent;
          border-top: 20px solid #e0e0e0;
          margin: 0 auto;
          margin-top: -1px;
          transition: border-top-color 0.3s ease;
        }

        .profile {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 15px;
        }

        .avatar {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          object-fit: cover;
          margin-right: 10px;
        }

        .name {
          font-size: 18px;
          font-weight: '600';
          color: #000;
        }

        /* Hover Effect Only on Icon + Triangle */
        .testimonial-group:hover .quote-icon {
          color: gray;
        }

        .testimonial-group:hover .triangle {
          border-top-color: #d4a017;
        }

        @media (max-width: 768px) {
          .testimonial-text {
            font-size: 15px;
          }
          .name {
            font-size: 16px;
          }
        }

        @media (max-width: 480px) {
          .testimonial-text {
            font-size: 14px;
          }
        }
      `}</style>
    </section>
  );
};

export default TestimonialsSection;
